import React from 'react';
import PropTypes from 'prop-types';
import { Modal } from 'react-bootstrap';
import './RecordPaymentStyle.css';
import { connect } from 'react-redux';
import { recordPaymentRequest } from 'actions/reports/invoices';
import { isValid } from 'redux-form';
import RecordPaymentForm from './RecordPaymentForm';

class RecordPaymentModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isClicked: false,
    };
  }

  render() {
    const {
      openRecordPaymentModal,
      closeRecordPaymentModal,
      onClickCancel,
      dispatch,
      isValidForm,
    } = this.props;
    return (
      <div className="modal-invoice">
        <Modal
          onHide={closeRecordPaymentModal}
          show={openRecordPaymentModal}
          bsClass="full-height-modal margin-top-modal modal"
        >
          <Modal.Header>
            <h4 className="modal-title">Record Payment</h4>
          </Modal.Header>
          <Modal.Body>
            <div className="invoice">
              <div className="row">
                <div className="col-sm-12">
                  <RecordPaymentForm
                    dispatch={dispatch}
                    amountDue={
                      this.props.data.reports.invoices.receiptInvoices
                        .total_amount_due
                    }
                    createdDate={
                      this.props.data.reports.invoices.receiptInvoices
                        .created_at
                    }
                  />
                </div>
              </div>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <div className="pull-left">
              <button
                type="button"
                className="btn btn-default"
                onClick={onClickCancel}
                data-dismiss="modal"
              >
                Cancel
              </button>
            </div>
            <div>
              <button
                type="submit"
                onClick={this.handleSubmit}
                disabled={!isValidForm || this.state.isClicked}
                className="btn btn-primary pull-right"
              >
                Save
              </button>
            </div>
          </Modal.Footer>
        </Modal>
      </div>
    );
  }

  handleSubmit = recordPayment => {
    this.setState({ isClicked: true });
    const { id, outlet_id } = this.props.data.reports.invoices.receiptInvoices;
    recordPayment = {
      id,
      payment_record: this.props.data.form.recordPaymentForm.values,
    };
    this.props.dispatch(
      recordPaymentRequest({ recordPayment, outletId: outlet_id })
    );
  };
}

RecordPaymentModal.propTypes = {
  openRecordPaymentModal: PropTypes.bool,
  closeRecordPaymentModal: PropTypes.func,
  onClickCancel: PropTypes.func,
  data: PropTypes.object,
  dispatch: PropTypes.func,
};

function mapStateToProps(state) {
  const { openRecordPaymentModal } = state.reports.invoices;
  return {
    openRecordPaymentModal,
    data: {
      reports: state.reports,
      form: state.form,
    },
    isValidForm: isValid('recordPaymentForm')(state),
  };
}

export default connect(mapStateToProps)(RecordPaymentModal);
